// extracted by mini-css-extract-plugin
module.exports = {"accordionTitle":"ProductDeliveryOptionsAccordion_accordionTitle__d06fq"};